import { FieldLabel } from '@if/mui'
import { Stack, ToggleButton, ToggleButtonGroup } from '@mui/material'
import type { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { getQuickDatePresetRange, QuickDatePreset } from '../statistics-hooks'

const PRESET_ORDER = [
  QuickDatePreset.Last30Days,
  QuickDatePreset.Last90Days,
  QuickDatePreset.ThisMonth,
  QuickDatePreset.ThisYear,
] as const

interface QuickDatePresetsProps {
  fromDate: string
  toDate: string
  onSelect: (preset: QuickDatePreset) => void
}

export const QuickDatePresets = ({ fromDate, toDate, onSelect }: QuickDatePresetsProps) => {
  const { t } = useTranslation()

  const activePreset =
    PRESET_ORDER.find((preset) => {
      const range = getQuickDatePresetRange(preset)
      return range.fromDate === fromDate && range.toDate === toDate
    }) ?? null

  const handleChange = (_: MouseEvent<HTMLElement>, preset: QuickDatePreset | null) => {
    if (preset) onSelect(preset)
  }

  return (
    <Stack spacing={0.5}>
      <FieldLabel>{t('merchantStatistics.performance.presetsLabel')}</FieldLabel>
      <ToggleButtonGroup value={activePreset} exclusive onChange={handleChange} size="small">
        {PRESET_ORDER.map((preset) => (
          <ToggleButton key={preset} value={preset}>
            {t(`merchantStatistics.performance.presets.${preset}`)}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Stack>
  )
}
